import Vue from 'vue';
import Login from '../components/Login';
import Posts from '../components/Posts';
import Preview from '../components/Preview';
import { getAuth } from "firebase/auth";
import Router from 'vue-router';
import NotAllowed from '../components/NotAllowedView';
import AttendanceSheet from '../components/AttendanceSheet.vue';
import AttendanceSheetDiagram from '../components/AttendanceSheetDiagram.vue';
import { httpsCallable } from "firebase/functions"
import { functions } from "../firebase.js"

Vue.use(Router)

const router = new Router({
    mode: 'history',
    routes: [
        {
            path: '*',
            redirect: '/notallowed'
        },
        {
            path: '/',
            redirect: '/notallowed'
        },
        {
            path: '/token/:token',
            name: 'token',
            component: Login,
            meta: {
                requiresAuth: false
            }
        },
        {
            path: '/posts',
            name: 'posts',
            component: Posts,
            meta: {
                requiresAuth: true
            }
        },
        {
            path: '/notallowed',
            name: 'NotAllowed',
            component: NotAllowed,
            meta: {
                requiresAuth: false
            }
        },
        {
            path: '/preview/:key',
            name: 'preview',
            component: Preview,
        },
        {
            path: '/attendanceSheet',
            name: 'AttendanceSheet',
            component: AttendanceSheet,
            meta: {
                requiresAuth: true
            }
        },
        {
            path: '/attendanceSheetDiagram',
            name: '/AttendanceSheetDiagram',
            component: AttendanceSheetDiagram,
            meta: {
                requiresAuth: true
            }
        }
    ]
});

router.beforeEach(async (to, from, next) => {
    const auth = getAuth();
    const currentUser = await auth.currentUser;
    const requiresAuth = to.matched.some(record => record.meta.requiresAuth)
    const getIdTokenResult = currentUser ? await currentUser.getIdTokenResult() : false
    const isUser = getIdTokenResult ? getIdTokenResult.claims.user : false

    if ((to.name === 'login' || to.name === 'NotAllowed') && currentUser && isUser) next({ name: 'posts' })
    else if (to.name === "preview" && to.params.key === "nokey" && currentUser && isUser) {
        const tokenRequest = httpsCallable(functions, 'fetchFrontendToken');
        const token = await tokenRequest()
        const key = token.data ? token.data : "could not fetch the frontend key.";
        next({ name: "preview", params: { key: key } })
    }
    else if (to.name === "preview" && to.params.key) { next() }
    else if (to.name !== 'NotAllowed' && !isUser && currentUser && requiresAuth) next({ name: 'NotAllowed' })
    else if (requiresAuth && currentUser) next()
    else if (requiresAuth && !currentUser) next({ name: 'NotAllowed' })
    else next()
})

export default router